// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "(max-width: 1024px) and (min-width: 601px)";
var _3 = "paper-1kt3F";
export { _1 as "__esModule", _2 as "tablet_only", _3 as "paper" }
export default { "__esModule": _1, "tablet_only": _2, "paper": _3 }
